module.exports = __webpack_public_path__ + "static/media/tools.10afcfb1.svg";